module.exports = __webpack_public_path__ + "static/media/EricOh.ba2f27c0.png";